export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-video-44e5efa655482cd6f655ad2444738ffa.svg";